import { IRootState } from '../../../store'
import { ISignaturesState } from '../store/signatures.types'

export const getSignaturesSelector = (state: IRootState): ISignaturesState => state.signatures
